import React from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingWizard from './onboarding/OnboardingWizard';

/**
 * OnboardingPage Component
 * Wraps the OnboardingWizard and provides a full-page onboarding experience.
 * This page hides all navigation and other app content.
 * NOTE: Onboarding status check is now handled at App.js level to prevent flashing
 */
function OnboardingPage() {
  const navigate = useNavigate();

  const handleComplete = (data) => {
    
    // Dispatch event to notify App.js that onboarding is complete
    // This allows App.js to immediately update state before navigation
    window.dispatchEvent(new CustomEvent('onboardingCompleted', {
      detail: { completed: true }
    }));
    
    // Redirect to dashboard immediately after completion
    // The backend has already marked onboarding as completed
    navigate('/', { replace: true });
  };

  return (
    <s-page>
      <OnboardingWizard onComplete={handleComplete} />
    </s-page>
  );
}

export default OnboardingPage;

